/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum ErrorCodes {
    UploadFile_ExtensionNotAllowedToBeUpload = 100001,
    UploadFile_FileSizeTooBig = 100002,
    UploadFile_Failed = 100003,
    LoadPicture_Failed = 100004,
    DepartmentAssignedToOtherEntity = 100034,
    DuplicateEmailOnAnotherEmployee = 100064,
    DuplicateCusomterNumberOnAnotherCustomer = 100012,
    CustomerPaymentTermAssignedToCustomer = 100068,
    CustomerPriceGroupAssignedToCustomer = 100069,
    PublicLoginFailedUserNamePasswordIsInvalid = 110001,
    PublicLoginFailedLoginDisabled = 110002,
    PublicLoginFailedUnknownIdentity = 110003,
    PublicLoginFailedRefreshTokenNotValid = 110004,
    PublicLoginInvalidPassword = 110005,
    UnableToDeleteLockColumn = 100024,
    AlreadyActivated = 100036,
    NoPhoneNumberFoundOnTemp = 100035,
    NoEmailNumberFoundOnTemp = 100053,
    BlockedPublicAccess = 100054,
    RoleAssignedToCustomerSalePerson = 100055,
    InstructionCategoryAssignedToInstruction = 100070,
    LabelIsReferenced = 120000,
    LabelNameNotValid = 120001,
    LabelProjectIdentifierNotValid = 120002,
    LabelIdentifierNotValid = 120003,
    LabelEntityIdentifierNotValid = 120004,
    LabelPrimaryReferenceKeyIdentifierNotValid = 120005,
    LimitReached = 130000,
    SystemProductTypeNotExist = 140001,
    ProductTypeIsntSystemProductType = 140002,
    SystemPackageConnectionExist = 140003,
    EntryPointAlreadyExists = 140004,
    SystemPackageAlreadyInUse = 140005,
    SystemPackageLineAlreadyInUse = 140006,
    /**
     * Errorcode for unhandledexception
     */
    UnhandledException = 200001,
    /**
     * Errorcode for applicationsettingmissing
     */
    ApplicationSettingMissing = 200002,
    /**
     * Used by Filehandler when something goes wrong
     */
    FileOperationError = 200003,
    /**
     * Used by frontend to throw some sort of frontend error message to logs.
     */
    FrontEndError = 200004,
    /**
     * Used by Filehandler when something goes wrong
     */
    FileOperatonPrefixFileRefNotSet = 200005,
    /**
     * Used when current Identity does not have a specific permission
     */
    PermissionDenied = 200006,
    ProductPictureIsPrimary = 200007,
    PictureIsLocked = 200008,
    /**
     * Errorcode for notfound
     */
    NotFound = 200010,
    /**
     * Errorcode for GetByIdNotFound
     */
    GetByIdNotFound = 200011,
    /**
     * Errorcode for mismatch
     */
    Mismatch = 200020,
    /**
     * Used for Id Mismatch in PUT controller endpoints. Data1 contains ID from route. Data2 contains ID from DTO.
     */
    IdMismatch = 200021,
    /**
     * Errorcode for invalid object
     */
    InvalidObject = 200030,
    /**
     * Errorcode for expired "object"
     */
    ObjectExpired = 200031,
    /**
     * Errorcode for duplicateobject
     */
    DuplicateObject = 200040,
    /**
     * Used for missing property. Data1 contains name of the missing property.
     */
    RequiredPropertyMissing = 200050,
    /**
     * Used for property that is not allowed when creating new element . Data1 contains name of the property.
     */
    PropertyNotAllowedForNewElement = 200055,
    /**
     * N/A
     */
    FromDateEqual = 200060,
    /**
     * End Date should be greater than start date
     */
    EndDateShouldbeGreater = 200070,
    PasswordRequiresDigit = 200080,
    PasswordRequiresLower = 200081,
    PasswordRequiresUpper = 200082,
    PasswordRequiresNonAlphanumeric = 200083,
    PasswordTooShort = 200084,
    ValueProvidedTooLong = 200085,
    CurrentPasswordMismatch = 200086,
    PictureIsPrimary = 200087,
    /**
     * Thrown by frontend when translation is missing - stored in Sentry
     */
    TranslationMissing = 200090,
    GoogleCaptchaValidationFailed = 200091,
}
